export interface IMetaState {
  title: string;
  imageSrc?: string;
}

const initialState: IMetaState = {
  title: "TUNE.KR",
  imageSrc: "",
};

const SET_META_TAG = "META/SET_META_TAG" as const;
const CLEAR_META_TAG = "META/CLEAR_META_TAG" as const;

export const meta = (state = initialState, action: TMetaAction) => {
  switch (action.type) {
    case SET_META_TAG:
      return {
        ...state,
        ...action.meta,
      };
    case CLEAR_META_TAG:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

type TMetaAction = ReturnType<typeof setMetaTag> | ReturnType<typeof clearMetaTag>;

const setMetaTag = (_meta: { title: string; imageSrc?: string }) => ({ type: SET_META_TAG, meta: _meta });
const clearMetaTag = () => ({ type: CLEAR_META_TAG });

export const metaTagCreator = {
  setMetaTag,
  clearMetaTag,
};
